// extracted by mini-css-extract-plugin
export default {"btnSend":"SendButton_btnSend__2cUxv","multiple":"SendButton_multiple__gUISn","Sent":"SendButton_Sent__tplPe"};